export default __webpack_public_path__ + "static/media/904.45820af5.png";